import {
  Badge,
  Box,
  Button,
  HStack,
  IconButton,
  Spacer,
  StackDivider,
  Text,
  VStack,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";

function Todos({ Data, deleteTodo, togglestatus }) {
  if (!Data.length) {
    return (
      <Badge colorScheme="green" p="4" m="4" borderRadius="lg">
        No TODOS !
      </Badge>
    );
  }
  return (
    <VStack
      divider={<StackDivider />}
      borderColor="gray.500"
      borderWidth="2px"
      borderRadius="lg"
      p="4"
      w="100%"
      maxW={{ base: "90vw", sm: "80vw", lg: "50vw", xl: "40vw" }}
      alignItems="stretch">
      <HStack>
        <Text>Name</Text>
        <Spacer />
        <Text>Status</Text>
        <Spacer />
        <Text>Toggle </Text>
        <Spacer />
        <Text>Delete </Text>
      </HStack>
      {Data.map((item) => (
        <Box key={item.id}>
          <HStack>
            <Text>{item.name}</Text>
            <Spacer />
            <Badge
              colorScheme={item.status ? "green" : "red"}
              p="4"
              m="4"
              borderRadius="lg">
              {item.status ? "Done" : "Pendoing"}
            </Badge>
            <Spacer />
            <Button onClick={() => togglestatus(item.id)}>Toggle</Button>
            <Spacer />
            <IconButton
              icon={<DeleteIcon />}
              isRound="true"
              onClick={() => deleteTodo(item.id)}
            />
          </HStack>
        </Box>
      ))}
    </VStack>
  );
}

export default Todos;
